import { Campaign } from '@/models/reward';
import { Routes } from '@/router';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { GETTERS as CUSTOMER_GETTERS } from '@/store/customer';

@Component({
  name: 'CmgLeaderboardTile',
})
export default class CmgLeaderboardTile extends Vue {

  get campaigns(): Campaign[] {
    return this.$appStore.state.reward.campaigns;
  }
  get summerExtraCampaign(): Campaign | undefined {
    return this.campaigns.find(c => c.campaignType === 'summerExtra' && c.isMultiStepCampaign === false);
  }
  get isActivated(): boolean {
    return Boolean(this.summerExtraCampaign?.isOptedIn);
  }

  get isMobile(): boolean {
    return this.$services.ui.isMobile();
  }

  get summerExtrasLogo(): string {
    return this.$appStore.state.cms.images.loyalty.summerOfExtras.default;
  }

  get arrowRightIcon(): string {
    return this.$appStore.state.cms.images.loyalty.transparentRightArrow.default;
  }

  get description(): string {
    return 'It\'s Extra everything. Extra points, Extra badges, and Extra reasons to order.';
  }

  get activatedImg(): string {
    return this.$appStore.state.cms.images.icons.activatedCheckmark.default;
  }

  get isOptedInSummerOfChipotle(): boolean {
    return this.$appStore.getters[CUSTOMER_GETTERS.IS_OPTED_IN_SUMMER_OF_CHIPOTLE];
  }

  onTileClick(): void {
    if (this.isActivated) {
      if(!this.isOptedInSummerOfChipotle) {
        this.$services.customer.optInCustomerToSummerOfChipotle();
      }
      this.$router.push({ name: Routes.Leaderboard });
    } else {
      this.showEducator();
    }
  }

  private showEducator(): void {
    const campaign = this.summerExtraCampaign;
    const isActivated = this.isActivated;
    if (campaign) {
      this.$services.ui.setModalVisibility('summerLeaderboardEducator', true, { campaign, isActivated });
    }
    Vue.nextTick(() => this.$services.ui.focusDiv('.fullModal'));
  }
}
